<template>
  <div class="home">
    
    
  </div>
  <div class="grid">
    <div class="col-12">
          <Chartingresosegresos gYear="2025" v-bind:gEjercicios="ejercicioscfdis"  />
    </div>
    
    <div class="col-12">
      <smart-widget-grid :layout="cards">
        <!-- layout[$].i as slot name -->
        <template #1>
          <smart-widget simple>
            <div class="layout-center">
              <div class="bg-surface-0  p-3 rounded-2xl bg-white  border-round-sm">
                <div class="grid">
                  <div class="col-12">
                    <div class="flex flex-wrap vertical-align-bottom">
                        <div class="flex">
                          <Chip class=" py-0 pl-3 pr-0">
                            <span class="mr-2 font-medium"> COMPROBANTES </span>
                            <span class="bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center">PPD</span>
                          </Chip>
                        </div>
                        <div class="flex">
                            <SelectButton class="ml-3" v-model="numppd_tdoc" :options="itemsEmitidosRecibidos" aria-labelledby="basic"  @click="onSelectYearPPD()"/>
                        </div>
                        <div class="flex">
                          <Dropdown
                            v-model="numppd_ayear"
                            :options="ejercicioscfdis"
                            id="comboejerciciocfdisppd"
                            style="width: 100px"
                            class="ml-2"
                            @change="onSelectYearPPD()"
                          />
                        </div>
                    </div>
                  </div> 
                  
                </div>
                <divider class="p-0 ml-0 mt-1 mb-1 mr-0 bg-primary"></divider>
                <DataTable :value="rowsnumerosppd" size="small" class="p-datatable-sm pepetable">
                  <Column field="descripcion" header="Estado"></Column>
                  <Column field="Enero" header="Ene"></Column>
                  <Column field="Febrero" header="Feb"></Column>
                  <Column field="Marzo" header="Mar"></Column>
                  <Column field="Abril" header="Abr"></Column>
                  <Column field="Mayo" header="May"></Column>
                  <Column field="Junio" header="Jun"></Column>
                  <Column field="Julio" header="Jul"></Column>
                  <Column field="Agosto" header="Ago" ></Column>
                  <Column field="Septiembre"  header="Sep" ></Column>
                  <Column field="Octubre" header="Oct" ></Column>
                  <Column field="Noviembre" header="Nov" ></Column>
                  <Column field="Diciembre" header="Dic" ></Column>
                </DataTable>
                
              </div>
            </div>
          </smart-widget>
        </template>
        <template #0>
          <smart-widget simple>
            <div class="layout-center">
              <div class="p-3 border-round-sm bg-white border-50  ">
                <div class="grid">
                  <div class="col-12">
                    <div class="flex flex-wrap vertical-align-bottom">
                      <Chip class="py-0 pl-3 pr-0">
                          <span class="mr-2 font-medium"> COMPROBANTES </span>
                      </Chip>
                      <SelectButton class="ml-3" v-model="numc_tdoc" :options="itemsEmitidosRecibidos" aria-labelledby="basic"  @click="onSelectYearCFDIS1()"/>
                      <Dropdown
                          v-model="numc_ayear"
                          :options="ejercicioscfdis"
                          id="comboejerciciocfdis1"
                          style="width: 100px"
                          class="ml-2"
                          @change="onSelectYearCFDIS1()"
                      />
                      <Chip class="ml-2 py-0 pl-2 pr-0">
                          <span class="mr-2 font-medium"> Vigentes </span>
                      </Chip>
                    </div>
                    
                  </div> 
                  
                  
                </div>
                <divider class="p-0 ml-0 mt-1 mb-1 mr-0 bg-primary"></divider>
                  <DataTable :value="rowsnumeroscomprobantes" size="small" class="p-datatable-sm pepetable">
                      <Column field="tipodecomprobante" header="Tipo"></Column>
                      <Column field="Enero" header="Ene"></Column>
                      <Column field="Febrero" header="Feb"></Column>
                      <Column field="Marzo" header="Mar"></Column>
                      <Column field="Abril" header="Abr"></Column>
                      <Column field="Mayo" header="May"></Column>
                      <Column field="Junio" header="Jun"></Column>
                      <Column field="Julio" header="Jul"></Column>
                      <Column field="Agosto" header="Ago"></Column>
                      <Column field="Septiembre" header="Sep"></Column>
                      <Column field="Octubre" header="Oct"></Column>
                      <Column field="Noviembre" header="Nov"></Column>
                      <Column field="Diciembre" header="Dic"></Column>
                      <Column field="Total" header="Total"></Column>
                      <ColumnGroup type="footer">
                          <Row>
                              <Column footer="Totales" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Enero']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Febrero']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Marzo']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Abril']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Mayo']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Junio']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Julio']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Agosto']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Septiembre']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Octubre']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Noviembre']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Diciembre']" />
                              <Column :footer="rowsnumeroscomprobantestotales[0]['Total']" />
                              
                          </Row>
                      </ColumnGroup>
                  </DataTable>
              </div>
            </div>
          </smart-widget>
        </template>
        
      </smart-widget-grid>
    </div>


  </div>
</template>

<script>

import { definiciones } from "@/icontaelibs.js";
import Chartingresosegresos from '@/components/Chartingresosegresos.vue';
import Chartcuentas from '@/components/Chartcuentas.vue';

export default {
  components: {
        Chartingresosegresos,
        Chartcuentas,
  },
  data() {
    return {
      loading: [false, false, false],
      isLoading:false,
      empresaid:0,
      ejercicioscfdis:[],
      ejercicios:[],
      ejercicio:0,
      numc_ayear:0,
      numppd_tdoc:'Emitidos',
      numppd_ayear:0,
      numc_tdoc:'Emitidos',
      itemsEmitidosRecibidos:["Emitidos", "Recibidos"],
      cards : [
          { x: 0, y: 0, w: 6, h: 6, i: '0' },
          { x: 6, y: 0, w: 6, h: 6, i: '1' }
         
        ],
      polizas:[
        {poliza:"I-12", concepto:"Ventas del dia 12-01-2025", totalcargo:"12,000", totalabono:"12,000"},
        {poliza:"I-13", concepto:"Ventas del dia 13-01-2025", totalcargo:"15,500", totalabono:"15,500"},
        {poliza:"I-14", concepto:"Ventas del dia 14-01-2025", totalcargo:"11,800", totalabono:"11,800"}
      ],
      rowsnumeroscomprobantes:[ {xmes:1, E: 0, I: 0, N: 0, P: 0, T: 0  } ], 
      rowsnumeroscomprobantestotales:[ { Enero: 0, Febrero: 0, Marzo: 0, Abril: 0, Mayo: 0, Junio:0, Julio:0, Agosto:0, Septiembre:0, Octubre:0, Noviembre:0, Diciembre:0, Total:0 } ], 
      rowsnumerosppd:[{'descripcion':'', 'Enero':0, 'Febrero':0 }]  
      
    };
  },
  name: "Home",

  mounted() {
    if (!this.$store.getters.isEmpresa) {
      console.log("No hay una empresa seleccionada");
      this.$router.push({ name: "Empresas" });
    } else {
      this.empresaid = this.$store.getters.dataEmpresa.data.id;
      this.getEjercicioscfdis();
      this.getEjercicios();
      const d = new Date();
      this.ejercicio = d.getFullYear();
      this.numc_ayear =  this.ejercicio;
      this.numppd_ayear =  this.ejercicio;
      this.numppd_tdoc = 'Emitidos';
      this.numc_tdoc = 'Emitidos';
      this.getNumerosComprobantes();
      this.getNumerosPPD();
    }
    
  },

  methods: {

    onSelectYearPPD(){
          console.log('aquimichu..........1');
          //this.$refs.opPPD.hide();
          this.getNumerosPPD();
    },

    onSelectYearCFDIS1(){

          console.log('aquimichu..........2');
          this.getNumerosComprobantes();
    },


    getEjercicioscfdis() {
      this.isLoading = true;

      console.log('solictando ejercicios cfdis');
      console.log(this.empresaid);
      this.$axios
        .get(definiciones.URL_API +"/ejercicioscfdis?emp=" + this.empresaid)
        .then((response) => {
          console.log(response.data);
          this.ejercicioscfdis = response.data.rows;
          this.isLoading = false;
        });
    },

    getEjercicios() {
      this.isLoading = true;

      console.log('solictando ejercicios');
      console.log(this.empresaid);
      this.$axios
        .get(definiciones.URL_API +"/ejerciciossaldos?emp=" + this.empresaid)
        .then((response) => {
          console.log(response.data);
          this.ejercicios = response.data.rows;
          this.isLoading = false;
        });
    },

    getNumerosComprobantes() {
      this.isLoading = true;
      
      console.log('solictando comprobantes');
      console.log(this.empresaid);
      this.$axios
        .get(definiciones.URL_API +"/numeroscomprobantes?p=1&ayear=" +this.numc_ayear +
                "&emp=" +this.empresaid+"&tdoc="+this.numc_tdoc)
        .then((response) => {
          console.log('----------comprobantes.-------');
          console.log(response.data);
          if (response.data.resultado=='ok'){
            this.rowsnumeroscomprobantes = response.data.data;
            this.rowsnumeroscomprobantestotales = response.data.totales;
            console.log(this.rowsnumeroscomprobantestotales[0]['Enero']);
            
          }
          this.isLoading = false;
        });
    },

    getNumerosPPD() {
      this.isLoading = true;
      console.log('solictando comprobantes ppd');
      console.log(this.empresaid);
      this.$axios
        .get(definiciones.URL_API +"/numerosppd?p=1&ayear=" +this.numppd_ayear +
                "&emp=" +this.empresaid+"&tdoc="+this.numppd_tdoc)
        .then((response) => {
          console.log('----------comprobantes.-------');
          console.log(response.data);
          this.rowsnumerosppd = response.data.resumen;
          this.isLoading = false;
        });
    },

  }

};
</script>
<style scoped>
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
.pepetable {
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-family: Roboto, "Helvetica Neue", sans-serif;
 
}

.widget-body__content{
  padding: 4px 6px !important;
}
.app-container {
  text-align: center;
}
.vue-grid-item:not(.vue-grid-placeholder) {
   
    border: 1px solid rgb(167, 62, 62);
}
.vue-grid-item .vue-resizable{
   
    border: 1px solid rgb(25, 43, 202);
}

.container .vue-grid-item.vue-grid-placeholder {
    background-color: green !important;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 2px 2px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
.vue-grid-item .add {
    cursor: pointer;
}

.vue-grid-item .resizing {
    opacity: 0.9;
}

.chipbutton {
      cursor: pointer; /* Changes the cursor to a hand pointer */
}

</style>
